import Quill from 'quill/core';
import React from 'react';
import useAppSelector, {
  useAppDispatch,
} from '../../../../app/redux/useAppSelector';
import { useQuill } from '../../../QuillContext';
import type { Blot } from '../../../types';
import { editIcon } from '../../editorIcons';
import ToolbarButton from './ToolbarButton';
import { EditorActions } from '../../../editorSlice';

interface ToolbarEditButtonProps {
  targetBlot?: Blot;
  onClick?: () => void;
}

const ToolbarEditButton = ({ targetBlot, onClick }: ToolbarEditButtonProps) => {
  const { quill } = useQuill();
  const dispatch = useAppDispatch();
  const isEditable = useAppSelector(
    (state) => !state.session.organization.isLocked && state.editor.editable,
  );
  return (
    <ToolbarButton
      icon={editIcon}
      onClick={() => {
        if (quill && targetBlot) {
          const index = targetBlot.offset(quill.scroll);
          if (index >= 0) {
            quill.setSelection(index, targetBlot.length(), Quill.sources.USER);
          }
        }
        dispatch(EditorActions.readOnly(false));
        onClick?.();
      }}
      tooltip={
        isEditable ? null : 'This post is read-only and cannot be edited'
      }
      disabled={!isEditable}
      testId="editToolbarEditButton"
    >
      Edit
    </ToolbarButton>
  );
};

export default ToolbarEditButton;
